import React from "react";
import { Envelope, Telephone } from "react-bootstrap-icons";
const ContactUs = () => {
  const contactUsStyles = {
    // textAlign: "center",
    paddingTop: "5%",
    margin: "20px",
  };

  const h1 = {
    fontSize: "3.5rem",
  };
  const h2 = {
    fontSize: "1.5rem",
  };

  const leftbox = {
    float: "left",
    width: "35%",
    marginRight:'50px'
  };

  const middlebox = {
    float: "left",
    width: "30%",
  };

  const rightbox = {
    float: "right",
    width: "20%",
  };

  const contactUsDetails = {
    paddingTop: "40px",
  };
  return (
    <div style={contactUsStyles} className="contactUsDiv">
      <h1 style={h1}>We are always here for our customers!!</h1>

      <div style={contactUsDetails}>
        <div style={leftbox}>
          <h2 style={h2}>Contact Information</h2>
          <b>
            <p>
              Email <Envelope /> {" "}
              <a className="redirectLinks" href="mailto:avionaqua@gmail.com">
                avionaqua@gmail.com
              </a>
            </p>
            <p>
              Phone <Telephone />  <br /> 08323244219
            </p>
          </b>
        </div>

        <div style={middlebox}>
          <h2 style={h2}>Address</h2>
          <b>M/s. AVOIN AQUA <br /> SAHAKAR HOUSE <br /> MAULINGUEM <br /> BICHOLIM <br /> North Goa <br />Pin-403504</b>
        </div>

        <div style={rightbox}>
          <h2 style={h2}>Locate Us</h2>
          <a href="https://www.google.com/maps/place/Sahakar+Jal+Factory/@15.6177835,73.9700396,15z/data=!4m2!3m1!1s0x0:0x9063cba2cc91670?sa=X&ved=2ahUKEwie1ZCokfL6AhUuaGwGHf3nD5EQ_BJ6BAhAEAM">
            <img
              height={"150px"}
              width={"150px"}
              src="https://firebasestorage.googleapis.com/v0/b/avion-aqua.appspot.com/o/images%2FlocateUs.png?alt=media&token=59d37538-b88d-41d1-991c-8e22eb8d6ab6"
              alt=""
            />
          </a>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
